import { toJS } from 'mobx'
import { message, Modal } from 'hljd'
import { hashHistory } from 'react-router'
import Api from '@api/groupSetting'

class Store {
  SCHEDULE_SHOW = {
    title: '隐私设置',
    name: 'scheduleShow',
    options: [
      {
        value: 0,
        title: '档期对所有成员可见'
      },
      {
        value: 1,
        title: '档期仅对管理员可见'
      }
    ]
  }

  onChange = e => {
    const { name, value } = e.target
    this.settingParams[name] = value
    this.edit()
  }

  getSetting = async () => {
    const { success, data } = await Api.getSetting()
    if (success) {
      this.settingParams = data
    }
  }

  edit = async () => {
    const { success } = await Api.postSetting(toJS(this.settingParams))
    if (success) {
      message.success('操作成功')
    }
  }

  /**
   * TODO，三大校验是否有未完成订单
   */
  quitGroup = () => {
    Modal.confirm({
      title: '是否退出当前团队',
      onOk: () => {
        return new Promise(async (resolve, reject) => {
          const { success } = await Api.quitGroup()
          if (success) {
            resolve()
            hashHistory.push('/localMerchant/groupManage')
            // 退出团队后团队管理菜单需刷新
            window.location.reload()
          } else {
            reject()
          }
        })
      }
    })
  }
}

export default Store
